"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _UtilityButtonTertiary = require("./UtilityButtonTertiary");
var _UtilityButtonTertiaryInline = require("./UtilityButtonTertiaryInline");
var _interface = require("./interface");
var _propTypes = require("./propTypes");
var _react2 = require("@emotion/react");
const UtilityButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    variant = _interface.UtilityButtonVariant.Tertiary,
    colorScheme = _interface.UtilityButtonColorScheme.Default,
    ...props
  } = _ref;
  switch (variant) {
    case _interface.UtilityButtonVariant.TertiaryInline:
      return (0, _react2.jsx)(_UtilityButtonTertiaryInline.UtilityButtonTertiaryInline, (0, _extends2.default)({
        ref: ref
      }, props));
    case _interface.UtilityButtonVariant.TertiaryInlineWithUnderline:
      return (0, _react2.jsx)(_UtilityButtonTertiaryInline.UtilityButtonTertiaryInline, (0, _extends2.default)({
        ref: ref,
        hasUnderline: true
      }, props));
    case _interface.UtilityButtonVariant.Tertiary:
    default:
      return (0, _react2.jsx)(_UtilityButtonTertiary.UtilityButtonTertiary, (0, _extends2.default)({
        ref: ref,
        coloredBackground: colorScheme === _interface.UtilityButtonColorScheme.ColoredBackground
      }, props));
  }
});
var _default = exports.default = (0, _utils.composeStencilComponent)({
  baseComponent: UtilityButton,
  description: 'Utility button is a low priority action button.',
  displayName: 'UtilityButton',
  propTypes: _propTypes.utilityButtonPropTypes
});